import { createGlobalStyle } from 'styled-components'

import theme from 'components/styles/styledTheme'

export const dropdownBoxShadow = `0px 5px 14px 0px rgba(25, 72, 210, 0.20)`
export const boxShadowCard = `0px 0px 6px 0px rgba(25, 72, 210, 0.14);`

const Typography = createGlobalStyle`
  * {
    font-family: Figtree, sans-serif;
  }

  .typography-h1 {
    font-family: 'Poppins', sans-serif;
    font-size: 25px;
    font-weight: 500;
  }

  .typography-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 21px;
    font-weight: 500;
  }

  .typography-title-1 {
    font-family: 'Figtree', sans-serif;
    font-size: 21px;
    font-weight: 550;
  }

  .typography-title-2 {
    font-family: 'Figtree', sans-serif;
    font-size: 17px;
    font-weight: 550;
  }

  .typography-subtitle-1 {
    font-family: 'Figtree', sans-serif;
    font-size: 15px;
    font-weight: 550;
  }

  .typography-subtitle-2 {
    font-family: 'Figtree', sans-serif;
    font-size: 14px;
    font-weight: 600;
  }

  .typography-subtitle-3 {
    font-family: 'Figtree', sans-serif;
    font-size: 13px;
    font-weight: 600;
  }

  .typography-subtitle-4 {
    font-family: 'Figtree', sans-serif;
    font-size: 13px;
    font-weight: 450;
  }

  .typography-subtitle-5 {
    font-family: 'Figtree', sans-serif;
    font-size: 12px;
    font-weight: 600;
  }

  .typography-body-1 {
    font-family: 'Figtree', sans-serif;
    font-size: 14px;
    font-weight: 400;
  }

  .typography-body-2 {
    font-family: 'Figtree', sans-serif;
    font-size: 13px;
    font-weight: 400;
  }

  .typography-body-3 {
    font-family: 'Figtree', sans-serif;
    font-size: 12px;
    font-weight: 400;
  }
  .typography-subbody-3 {
    font-family: 'Figtree', sans-serif;
    font-size: 12px;
    font-weight: 300;
  }

  .box-shadow-table {
    border-radius: 10px;
    box-shadow: 0px 7px 10px 0px rgba(25, 72, 210, 0.20);
  }
  .box-shadow-dropdown {
    border-radius: 10px;
    box-shadow: ${dropdownBoxShadow};
  }
  .box-shadow-card {
    border-radius: 8px;
    box-shadow: ${boxShadowCard};
  }
  .box-shadow-drawer {
    border-radius: 10px;
    box-shadow: -7px 0px 14px 1px rgba(25, 72, 210, 0.20);
  }
  .box-shadow-page-tools-section {
    border-radius: 10px;
    box-shadow: 0px -3px 10px 0px rgba(25, 72, 210, 0.50);
  }
  .box-shadow-modal {
    border-radius: 8px;
    box-shadow: 0px 10px 48px 0px rgba(25, 72, 210, 0.30);
  }
  .box-shadow-tooltip {
    border-radius: 8px;
    box-shadow: 0px 0px 14px 0px rgba(25, 72, 210, 0.25);
    border: 1px solid ${theme.ds_blue_4};
  }
`

export default Typography
